var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShared(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_1120",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1120",
    transform: "translate(-94 85.773)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_1344",
    "data-name": "\\u9577\\u65B9\\u5F62 1344",
    width: 32,
    height: 32,
    transform: "translate(94 -85.773)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "USR-authentication_24",
    d: "M123.333-64.061a8.644,8.644,0,0,0-5.971-8.234.667.667,0,0,1-.454-.546.666.666,0,0,1,.3-.646,4.656,4.656,0,0,0,2.127-3.908,4.671,4.671,0,0,0-4.666-4.666A4.672,4.672,0,0,0,110-77.395a4.657,4.657,0,0,0,2.128,3.908.669.669,0,0,1,.3.646.669.669,0,0,1-.455.546,7.96,7.96,0,0,0-1.63.806.669.669,0,0,1-.914-.231.666.666,0,0,1,.232-.914c.256-.153.528-.314.824-.469a5.962,5.962,0,0,1-1.816-4.292,6.007,6.007,0,0,1,6-6,6.007,6.007,0,0,1,6,6,5.969,5.969,0,0,1-1.789,4.266,9.973,9.973,0,0,1,5.789,9.068A.667.667,0,0,1,124-63.4.667.667,0,0,1,123.333-64.061Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "USR-authentication_24-2",
    "data-name": "USR-authentication_24",
    d: "M111.333-57.4a8.644,8.644,0,0,0-5.971-8.233.669.669,0,0,1-.454-.547.667.667,0,0,1,.3-.646,4.653,4.653,0,0,0,2.127-3.907,4.672,4.672,0,0,0-4.666-4.667A4.673,4.673,0,0,0,98-70.728a4.654,4.654,0,0,0,2.128,3.907.67.67,0,0,1,.3.646.669.669,0,0,1-.455.547,7.96,7.96,0,0,0-1.63.806.669.669,0,0,1-.914-.232.666.666,0,0,1,.232-.914c.256-.152.528-.314.824-.468a5.962,5.962,0,0,1-1.816-4.292,6.006,6.006,0,0,1,6-6,6.007,6.007,0,0,1,6,6,5.966,5.966,0,0,1-1.789,4.265,9.975,9.975,0,0,1,5.789,9.068.667.667,0,0,1-.667.667A.667.667,0,0,1,111.333-57.4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShared);
export default __webpack_public_path__ + "static/media/shared.3f0841181ca533dd0f90b1c90e2ec166.svg";
export { ForwardRef as ReactComponent };